import { z } from 'zod';

import { unique } from '@vestigas/utils';

export const zodCompaniesByIdsAdminPayloadSchema = z.object({
  companyIds: z
    .array(z.uuid())
    .transform((companyIds) => unique(companyIds).toSorted())
    .pipe(z.array(z.uuid()).max(500)),
});

export const zodCompanyByIdsAdminSchema = z.object({
  companyAccountId: z.uuid(),
  id: z.uuid(),
  name: z.string(),
});

export const zodCompaniesByIdsAdminResponseSchema = z.object({
  data: z.array(zodCompanyByIdsAdminSchema),
});
